import React, { useState } from 'react';
import { Grid, TextField } from '@mui/material';
import _ from 'lodash';
import deepmerge from 'deepmerge';

import SelectField from '../../common/select_field';
import { getTheftRegistryOptions } from '../../common/utils/theft_registry_utils';
import { TheftRegistryStatusEnum } from '../../../core/enums/order/theft_registry';
import FilterPaper from '../../common/filter_paper';

const TheftRegistriesFilters = ({ queryParams, setQueryParams }) => {
    const [theftRegistryStatus, setTheftRegistryStatus] = useState(queryParams?.status || TheftRegistryStatusEnum.IN_REALIZATION.value);

    const onSelectTheftRegistryStatusChange = (event) => {
        setTheftRegistryStatus(event.target.value);
        setQueryParams(prevState => deepmerge(prevState, { status: event.target.value }));
    };

    const onSearchInputChangeDebounced = _.debounce((value) => onSearchInputChange(value), 600);

    const onSearchInputChange = (query) => {
        setQueryParams(prevState => deepmerge(prevState, { query: query }));
    };

    return (
        <FilterPaper title="Filtry kradzieży">
            <Grid container spacing={ 3 } alignItems="flex-start">
                <Grid item xs={ 12 } sm={ 6 } md={ 3 }>
                    <SelectField
                        size="small"
                        label="Status"
                        value={ theftRegistryStatus }
                        onChange={ onSelectTheftRegistryStatusChange }
                        options={ getTheftRegistryOptions }
                    />
                </Grid>
                <Grid item xs={ 12 } sm={ 6 } md={ 4 }>
                    <TextField
                        size="small"
                        label="Szukaj po ID albo numerze faktury"
                        fullWidth
                        placeholder={ queryParams?.query }
                        onChange={ event => onSearchInputChangeDebounced(event.target.value) }
                        InputLabelProps={ queryParams?.query ? { shrink: true } : undefined }
                    />
                </Grid>
            </Grid>
        </FilterPaper>
    );
};

export default TheftRegistriesFilters;